import React, { useState, useEffect} from 'react';
import { Modal, Button, OverlayTrigger, Tooltip } from 'react-bootstrap';
// import EditForm from './EditForm'



const User = ({user}) => {

    //const {deleteEmployee} = useContext(EmployeeContext)

    const [show, setShow] = useState(false);
    
    const handleShow = () => setShow(true);
    const handleClose = () => setShow(false);

    useEffect(() => {
        handleClose()
    }, [user])

    return (
        <>
            <td>{user.fullname}</td>
            <td>{user.email}</td>
            <td>{user.address}</td>
            <td><img src={user.avatar} height="50px" width="50px"></img></td>
            <td>
                <OverlayTrigger
                    overlay={
                        <Tooltip id={`tooltip-top`}>
                            Details
                        </Tooltip>
                    }>
                    <button onClick={handleShow}  className="btn text-warning btn-act" data-toggle="modal"><i className="fa fa-edit"></i></button>
                </OverlayTrigger>
                <OverlayTrigger
                    overlay={
                        <Tooltip id={`tooltip-top`}>
                            Block
                        </Tooltip>
                    }>
                    <button   className="btn text-danger btn-act" data-toggle="modal"><i className="fa fa-trash yellow-color"></i></button>
                </OverlayTrigger>
                
                
            </td>

        </>
    )
}

export default User;